module.exports = __webpack_public_path__ + "img/Google_Pay_Logo.657757f7.svg";